import $ from 'jquery';

import ChairishABTest from 'chairisher/abtest';
import Scroller from 'chairisher/component/scroller';

import { trackCategoryLinks, scrollToResultsIfNeeded } from 'chairisher/analytics/landingcontent';

/**
 * AB Test for determining if curated and promotional content at the top of the Furniture and Jewelry & Accessories
 * landing pages helps users narrow interest earlier in the session and surfaces high-converting product subsets,
 * resulting in increased conversion.
 *
 * TODO: (CHAIR-17250) Delete file after AB test is complete. Also: remove from files_with_linting_errors.txt
 */
export default class LandingContent extends ChairishABTest {
    static getExperimentName() {
        return 'LANDING_CONTENT_AB_TEST';
    }

    variation() {
        trackCategoryLinks();
        const $subcategoryLandingTileContainer = $('.js-subcategory-tiles-landing');
        if ($subcategoryLandingTileContainer.length) {
            const $tileListEl = $subcategoryLandingTileContainer.find('.js-tile-list');
            new Scroller({
                container: $subcategoryLandingTileContainer.get(0),
                containerBody: $tileListEl.get(0),
                children: $tileListEl.children().get(),
            });
        }

        $('#js-collection-test-module').removeClass('hidden');
        $('#content').addClass('landing-content-ab-test');
        $('#js-product-nav-horizontal').css('display', 'none');

        scrollToResultsIfNeeded();
    }
}
